import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterBlock } from '@cbridge-tools/filters-panel';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { Loader } from '@cbridge-tools/loader';
import { StreamsFilterAction } from '../../streamsFilter.action';
import { streamsFilterPropsSelector } from './StreamsFilter.selector';
import { StreamsFilterClearButton } from './StreamsFilterClearButton/StreamsFilterClearButton';
import { Stream } from './Stream/Stream';
import { IStreamsFilterProps } from './StreamsFilter.interface';

export const StreamsFilter: FC<IStreamsFilterProps> = ({ nodeId, serverId, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isLoading, items, hasOtherNodeSelection } = useSelector(streamsFilterPropsSelector, { nodeId, serverId });

  useEffect(() => {
    if (hasOtherNodeSelection) {
      dispatch(StreamsFilterAction.clearSelect());
    }
  }, [hasOtherNodeSelection, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(StreamsFilterAction.destroy());
    };
  }, [dispatch]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <FilterBlock
      label={t('text:configPage.streams.section.markupStreams')}
      clearFilterAction={<StreamsFilterClearButton />}
      items={items}
      FilterBlockItemComponent={Stream}
      {...props}
    />
  );
};
